import React from "react";
import "../../App.css";

function Jere() {
  return (
    <div className="aboutus-container">
      <h1 className="about-us">Jere Pineda</h1>
        <div class="aboutus-info">
          <div class="row">
            <div class="column">
              <div class="profileimg">
                <img src="images/JerePineda.jpg" alt="Jere"></img>
              </div>
            </div>
            <div class="column">
            <div class="aboutus-offer">
              <p><strong>2025 - Present: Doctor of Philosophy - Education</strong><br></br>
              Australian Catholic University - Melbourne Campus<br></br>
              Melbourne, Australia<br></br>
              <br></br>
              <strong>2022: Master of Science in Education with Specialisation in Chemistry</strong><br></br>
              Ateneo de Manila University<br></br>
              Quezon City, Philippines<br></br>
              
              <br></br>
              <strong>2018: Bachelor of Science in Education with Specialisation in Chemistry</strong><br></br>
              Philippine Normal University - Manila<br></br>
              Manila City, Philippines<br></br>
              </p>
              <p>I am a Filipino Chemistry Teacher with over seven years of experience teaching both high school and college
                students. I am a native Filipino speaker, and I am experienced in fostering lifelong learning skills and
                maintaining effective classroom management.
              </p>
            </div>  
          </div>
        </div>
      </div>
    </div>
  );
}

export default Jere;
